import { render } from "./CompanyLogo.vue?vue&type=template&id=ffedec70&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"

import "./CompanyLogo.vue?vue&type=style&index=0&id=ffedec70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffedec70"],['__file',"src/components/CompanyLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffedec70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffedec70', __exports__)) {
    console.log('reload')
    api.reload('ffedec70', __exports__)
  }
  
  module.hot.accept("./CompanyLogo.vue?vue&type=template&id=ffedec70&scoped=true", () => {
    console.log('re-render')
    api.rerender('ffedec70', render)
  })

}


export default __exports__